import React, { useState } from "react";

const globalStyles = `
:root {
  --bg: #020617;
  --accent: #f9a8d4;
  --accent-2: #a855f7;
  --text: #f9fafb;
  --muted: #9ca3c9;
}

*{margin:0;padding:0;box-sizing:border-box;}
body{
  background:
    radial-gradient(circle at 20% 0%, rgba(249,168,212,.08), transparent 40%),
    radial-gradient(circle at 80% 100%, rgba(129,140,248,.08), transparent 35%),
    #020617;
  color:var(--text);
  font-family:system-ui,-apple-system,BlinkMacSystemFont,"Segoe UI",sans-serif;
}

/* hero dashboard */
.hero-profile-wrapper{display:flex;justify-content:flex-end;}
.hero-profile{
  position:relative;
  width:100%;
  max-width:380px;
  padding:24px 20px 20px;
  border-radius:30px;
  overflow:hidden;
  background:
    radial-gradient(circle at 0% 0%, rgba(249,168,212,.35), transparent 55%),
    radial-gradient(circle at 100% 100%, rgba(129,140,248,.32), transparent 55%),
    linear-gradient(155deg,#0b1220 0%,#020617 50%,#0b1220 100%);
  border:1px solid rgba(148,163,184,.85);
  box-shadow:0 30px 90px rgba(15,23,42,.95),inset 0 0 20px rgba(255,255,255,.02);
}
.hero-profile-header{display:flex;align-items:center;justify-content:space-between;margin-bottom:14px;}
.hero-avatar{display:flex;align-items:center;gap:12px;}
.avatar-circle{
  width:60px;height:60px;border-radius:999px;padding:3px;
  background:linear-gradient(135deg,#f9a8d4,#fecdd3,#a5b4fc);
  box-shadow:0 10px 25px rgba(249,168,212,.75),0 0 0 1px rgba(15,23,42,.9);
  display:flex;align-items:center;justify-content:center;
}
.avatar-circle-inner{
  width:100%;height:100%;border-radius:inherit;
  background:radial-gradient(circle at 25% 20%,#111827,#020617 70%);
  display:flex;align-items:center;justify-content:center;
  font-size:13px;font-weight:700;letter-spacing:.08em;color:#e5e7eb;
}
.avatar-circle-inner::before{content:"Jenny";}
.hero-profile-main{margin-top:4px;}
.stats-grid{display:grid;gap:8px;margin-bottom:10px;}
.stats-grid-3{grid-template-columns:repeat(3,minmax(0,1fr));}
.stat-card{
  border-radius:18px;
  padding:10px 9px;
  border:1px solid rgba(148,163,184,.7);
  background:radial-gradient(circle at top,rgba(15,23,42,.8),#020617);
}
.stat-label{font-size:10px;text-transform:uppercase;letter-spacing:.12em;color:var(--muted);margin-bottom:4px;}
.stat-value{font-size:18px;font-weight:600;margin-bottom:2px;}
.stat-sub{font-size:11px;color:#cbd5f5;}
.hero-profile-tags{display:flex;flex-wrap:wrap;gap:6px;margin-top:6px;}
.hero-profile-tag{
  font-size:10px;padding:4px 8px;border-radius:999px;
  border:1px dashed rgba(148,163,184,.7);
  background:rgba(15,23,42,.96);color:#e5e7eb;
}
.hero-profile-footer{
  margin-top:10px;padding-top:8px;
  display:flex;align-items:center;justify-content:space-between;
  border-top:1px solid rgba(148,163,184,.5);
  font-size:11px;color:var(--muted);
}
.hero-profile-cta{
  font-size:11px;padding:5px 12px;border-radius:999px;
  background:radial-gradient(circle at 0 0,rgba(249,168,212,.5),rgba(15,23,42,.96));
  border:1px solid rgba(249,168,212,.85);
  color:#f9fafb;box-shadow:0 10px 26px rgba(249,168,212,.85);
  text-decoration:none;
}

/* experience cards */
.exp-card{
  display:flex;gap:16px;
  padding:18px 16px;
  border-radius:18px;
  border:1px solid rgba(249,168,212,.45);
  background:radial-gradient(circle at top left,rgba(249,168,212,.12),#020617);
  box-shadow:0 14px 32px rgba(0,0,0,.45);
}
.exp-logo{
  width:52px;height:52px;border-radius:14px;
  background:#fff;border:1px solid rgba(249,168,212,.6);
  object-fit:contain;padding:6px;
}
.letter-box{
  display:inline-block;
  padding:4px 6px;margin-right:3px;
  border-radius:6px;
  border:1px solid rgba(249,168,212,.4);
  background:rgba(249,168,212,.08);
  color:#f9a8d4;
  font-weight:600;font-size:14px;
}
.exp-title{margin-bottom:4px;}
.exp-role{display:block;font-size:13px;color:#cbd5f5;margin-top:6px;}
.exp-details{margin-top:8px;font-size:14px;color:#cbd5f5;line-height:1.55;padding-left:18px;}
.exp-details li{margin-bottom:4px;}
/* contact / elsewhere links */
.elsewhere-item{
  display:flex;
  align-items:center;
  gap:8px;
  margin-bottom:6px;
  color:#e5e7eb;
}

.elsewhere-item:last-child{
  margin-bottom:0;
}

.elsewhere-pill{
  display:inline-flex;
  align-items:center;
  padding:4px 12px;
  border-radius:999px;
  border:1px solid rgba(249,168,212,.6);
  background:
    radial-gradient(circle at 0 0,rgba(249,168,212,.22),rgba(15,23,42,.98));
  color:#fdf2ff;
  font-size:13px;
  text-decoration:none;
  box-shadow:0 8px 22px rgba(15,23,42,.9);
  transition:
    background 160ms ease-out,
    box-shadow 160ms ease-out,
    transform 120ms ease-out,
    color 160ms ease-out;
}

.elsewhere-pill:hover{
  transform:translateY(-1px);
  background:
    radial-gradient(circle at 0 0,rgba(249,168,212,.4),rgba(15,23,42,1));
  box-shadow:0 12px 30px rgba(249,168,212,.4);
}

.elsewhere-pill:active{
  transform:translateY(0);
  box-shadow:0 4px 14px rgba(0,0,0,.7);
}

.elsewhere-pill:visited{
  color:#fdf2ff;
}

/* bubble buttons + ripple */
.soft-bubble-button{position:relative;overflow:hidden;}
.soft-bubble-button-bubble{
  position:absolute;width:95px;height:95px;border-radius:9999px;
  filter:blur(2px);opacity:.7;
  transform:translate(-50%,-50%) scale(.9);
  pointer-events:none;
  background:radial-gradient(circle at 30% 30%,rgba(255,255,255,.9),rgba(249,168,212,.7),rgba(249,168,212,0));
  animation:bubbleFloat 6s ease-in-out infinite;
}
.soft-bubble-button.is-hovered .soft-bubble-button-bubble{
  animation:bubblePop .26s ease-out,bubbleFloat 6s ease-in-out .26s infinite;opacity:1;
}
@keyframes bubbleFloat{
  0%{transform:translate(-50%,-50%) scale(.9);}
  50%{transform:translate(-50%,-58%) scale(1.08);}
  100%{transform:translate(-50%,-50%) scale(.9);}
}
@keyframes bubblePop{
  0%{transform:scale(.2);opacity:0;}
  80%{transform:scale(1.2);opacity:1;}
  100%{transform:scale(1);opacity:.8;}
}
.ripple-circle{
  position:absolute;width:16px;height:16px;border-radius:9999px;
  background:radial-gradient(circle,rgba(255,255,255,.9),rgba(249,168,212,.6),transparent);
  transform:translate(-50%,-50%) scale(.2);
  opacity:1;pointer-events:none;
  animation:rippleAnim .7s ease-out;
}
@keyframes rippleAnim{
  0%{transform:scale(.2);opacity:1;}
  60%{transform:scale(12);opacity:.65;}
  100%{transform:scale(18);opacity:0;}
}
@keyframes gradientShiftBG{
  0%{background-position:0% 50%;}
  50%{background-position:100% 50%;}
  100%{background-position:0% 50%;}
}
`;

type AnimatedButtonProps = React.ButtonHTMLAttributes<HTMLButtonElement> & {
  variant?: "primary" | "secondary" | "resume";
};

const AnimatedButton: React.FC<AnimatedButtonProps> = ({
  children,
  variant = "primary",
  style,
  onClick,
  className,
  ...rest
}) => {
  const [transform, setTransform] = useState("translate3d(0,0,0)");
  const [hovered, setHovered] = useState(false);
  const [bubblePos, setBubblePos] = useState({ x: 50, y: 50 });
  const [ripple, setRipple] = useState<null | {
    x: number;
    y: number;
    key: number;
  }>(null);

  const handleMouseMove = (e: React.MouseEvent<HTMLButtonElement>) => {
    const rect = e.currentTarget.getBoundingClientRect();
    const x = e.clientX - rect.left;
    const y = e.clientY - rect.top;
    const relX = x / rect.width - 0.5;
    const relY = y / rect.height - 0.5;
    setTransform(
      `translate3d(${relX * 14}px, ${relY * 10}px, 0) rotateX(${
        relY * -10
      }deg) rotateY(${relX * 10}deg) scale(1.05)`
    );
    setBubblePos({ x: (x / rect.width) * 100, y: (y / rect.height) * 100 });
  };

  const handleMouseEnter = () => {
    setHovered(true);
    setTransform("translate3d(0,-4px,0) scale(1.04)");
  };

  const handleMouseLeave = () => {
    setHovered(false);
    setTransform("translate3d(0,0,0) rotateX(0) rotateY(0) scale(1)");
    setBubblePos({ x: 50, y: 50 });
  };

  const handleClick = (e: React.MouseEvent<HTMLButtonElement>) => {
    const rect = e.currentTarget.getBoundingClientRect();
    setRipple({
      x: e.clientX - rect.left,
      y: e.clientY - rect.top,
      key: Date.now(),
    });
    onClick?.(e);
  };

  let backgroundStyle: React.CSSProperties = {};
  let textColor = "#020617";

  if (variant === "primary") {
    backgroundStyle = {
      background: "linear-gradient(120deg,#f9a8d4,#f472b6,#f3e8ff)",
      backgroundSize: "220% 220%",
      animation: hovered ? "gradientShiftBG 4s ease infinite" : undefined,
    };
  } else if (variant === "resume") {
    backgroundStyle = {
      background: "linear-gradient(120deg,#f9a8d4,#fbcfe8,#f3e8ff)",
      backgroundSize: "220% 220%",
      animation: hovered ? "gradientShiftBG 4s ease infinite" : undefined,
    };
    textColor = "#111827";
  } else {
    backgroundStyle = {
      background: "linear-gradient(120deg,#020617,#0f172a,#020617)",
      backgroundSize: "200% 200%",
      animation: hovered ? "gradientShiftBG 4s ease infinite" : undefined,
    };
    textColor = "#e5e7eb";
  }

  return (
    <button
      {...rest}
      className={`soft-bubble-button ${hovered ? "is-hovered" : ""} ${
        className || ""
      }`}
      style={{
        padding: "10px 20px",
        borderRadius: 9999,
        border: "1px solid rgba(255,255,255,0.12)",
        cursor: "pointer",
        transform,
        transformStyle: "preserve-3d",
        transition: "transform 150ms ease-out,box-shadow 200ms ease-out",
        boxShadow: hovered
          ? "0 16px 38px rgba(249,168,212,.35)"
          : "0 8px 20px rgba(0,0,0,.25)",
        position: "relative",
        overflow: "hidden",
        ...backgroundStyle,
        ...style,
      }}
      onMouseEnter={handleMouseEnter}
      onMouseLeave={handleMouseLeave}
      onMouseMove={handleMouseMove}
      onClick={handleClick}
    >
      <span
        className="soft-bubble-button-bubble"
        style={{ left: `${bubblePos.x}%`, top: `${bubblePos.y}%` }}
      />
      <span
        style={{
          position: "relative",
          zIndex: 2,
          color: textColor,
          fontWeight: 600,
        }}
      >
        {children}
      </span>
      {ripple && (
        <span
          className="ripple-circle"
          style={{ left: ripple.x, top: ripple.y }}
          onAnimationEnd={() => setRipple(null)}
          key={ripple.key}
        />
      )}
    </button>
  );
};

const App: React.FC = () => {
  const scrollToProjects = () => {
    document.getElementById("projects")?.scrollIntoView({ behavior: "smooth" });
  };

  return (
    <>
      <style>{globalStyles}</style>
      <header
        style={{
          position: "sticky",
          top: 0,
          zIndex: 50,
          backdropFilter: "blur(16px)",
          background:
            "linear-gradient(to bottom,rgba(2,6,23,.96),rgba(2,6,23,.9),transparent)",
          borderBottom: "1px solid rgba(148,163,184,.3)",
        }}
      >
        <nav
          style={{
            maxWidth: 1120,
            margin: "0 auto",
            padding: "12px 18px",
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
          }}
        >
          <div style={{ display: "flex", alignItems: "center", gap: 12 }}>
            <div
              style={{
                width: 34,
                height: 34,
                borderRadius: "999px",
                background:
                  "conic-gradient(from 220deg,#f9a8d4,#a5b4fc,#e5e7eb,#f9a8d4)",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                fontWeight: 800,
                color: "#020617",
              }}
            >
              J
            </div>
            <div>
              <div
                style={{
                  fontSize: 14,
                  letterSpacing: "0.08em",
                  textTransform: "uppercase",
                }}
              >
                Jenny Nguyen
              </div>
              <div style={{ fontSize: 11, color: "var(--muted)" }}>
                Computer Science & Data Analytics @ Denison
              </div>
            </div>
          </div>
          <div style={{ display: "flex", gap: 12, alignItems: "center" }}>
            <a href="#about" style={{ color: "#cbd5f5", fontSize: 13 }}>
              About
            </a>
            <a href="#experience" style={{ color: "#cbd5f5", fontSize: 13 }}>
              Experience
            </a>
            <a href="#projects" style={{ color: "#cbd5f5", fontSize: 13 }}>
              Projects
            </a>
            <a href="#contact" style={{ color: "#cbd5f5", fontSize: 13 }}>
              Contact
            </a>
            <a
              href="https://drive.google.com/file/d/1NghH0pW9gGf-K7XgycO2THE0UR3HDRG5/view?usp=sharing"
              target="_blank"
              rel="noreferrer"
              style={{
                padding: "7px 14px",
                borderRadius: 999,
                background: "linear-gradient(135deg,#f9a8d4,#e5e7eb)",
                boxShadow: "0 10px 24px rgba(249,168,212,.7)",
                fontWeight: 600,
                color: "#020617",
                fontSize: 13,
                textDecoration: "none",
              }}
            >
              Resume ↗
            </a>
          </div>
        </nav>
      </header>

      <main>
        <div style={{ maxWidth: 1120, margin: "0 auto", padding: "30px 18px" }}>
          {/* HERO */}
          <section
            id="top"
            style={{
              display: "grid",
              gridTemplateColumns: "minmax(0,3fr) minmax(0,2fr)",
              gap: 32,
              alignItems: "center",
              marginTop: 32,
            }}
          >
            <div>
              <div
                style={{
                  display: "inline-flex",
                  alignItems: "center",
                  gap: 8,
                  padding: "6px 10px",
                  borderRadius: 999,
                  border: "1px solid rgba(249,168,212,.6)",
                  background: "rgba(15,23,42,.92)",
                  marginBottom: 14,
                  fontSize: 12,
                  color: "var(--muted)",
                }}
              >
                <span
                  style={{
                    width: 18,
                    height: 18,
                    borderRadius: "999px",
                    background:
                      "radial-gradient(circle at 25% 20%,#f9a8d4,#a5b4fc)",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    fontSize: 11,
                    color: "#020617",
                  }}
                >
                  ✨
                </span>
                Open to SWE & ML internships
              </div>
              <h1
                id="about"
                style={{
                  fontSize: 40,
                  fontWeight: 800,
                  lineHeight: 1.1,
                  marginBottom: 16,
                }}
              >
                Hi, I’m{" "}
                <span
                  style={{
                    background: "linear-gradient(135deg,#f9a8d4,#a5b4fc)",
                    WebkitBackgroundClip: "text",
                    color: "transparent",
                  }}
                >
                  Jenny Nguyen
                </span>
                .
                <br />I build reliable, data-driven systems.
              </h1>
              <p
                style={{
                  fontSize: 15,
                  color: "#cbd5f5",
                  maxWidth: 560,
                  marginBottom: 10,
                }}
              >
                I’m a Computer Science & Data Analytics student at Denison
                University who enjoys building scalable backend systems and
                ML-powered workflows.
              </p>

              <p
                style={{
                  fontSize: 15,
                  color: "#cbd5f5",
                  maxWidth: 560,
                  marginBottom: 22,
                }}
              >
                I’ve worked on everything from real-time trading platforms to
                fraud detection pipelines, combining clean system design with
                data-driven decision making.
              </p>

              <div style={{ display: "flex", flexWrap: "wrap", gap: 10 }}>
                <AnimatedButton variant="primary" onClick={scrollToProjects}>
                  See my projects ↓
                </AnimatedButton>
                <AnimatedButton
                  variant="secondary"
                  onClick={() =>
                    window.open(
                      "https://drive.google.com/file/d/1GT1DC65OL8LWIJfbCez8djHwMfEZgIUr/view?usp=sharing"
                    )
                  }
                >
                  📄 Resume
                </AnimatedButton>
                <AnimatedButton
                  variant="secondary"
                  onClick={() =>
                    window.open(
                      "https://drive.google.com/file/d/1NghH0pW9gGf-K7XgycO2THE0UR3HDRG5/view?usp=sharing"
                    )
                  }
                >
                  💼 LinkedIn
                </AnimatedButton>
                <AnimatedButton
                  variant="secondary"
                  onClick={() =>
                    window.open("https://github.com/jennykhanhnguyen")
                  }
                >
                  🧑‍💻 GitHub
                </AnimatedButton>
              </div>
            </div>

            <div className="hero-profile-wrapper">
              <aside className="hero-profile">
                <div className="hero-profile-header">
                  <div className="hero-avatar">
                    <div className="avatar-circle">
                      <div className="avatar-circle-inner" />
                    </div>
                    <div>
                      <div style={{ fontSize: 15, fontWeight: 600 }}>
                        Jenny Nguyen
                      </div>
                      <div style={{ fontSize: 12, color: "var(--muted)" }}>
                        Software & Machine Learning–curious
                      </div>
                    </div>
                  </div>
                  <div
                    style={{
                      padding: "6px 12px",
                      borderRadius: 999,
                      border: "1px solid rgba(249,168,212,.85)",
                      background: "rgba(15,23,42,.92)",
                      fontSize: 11,
                      color: "#f9fafb",
                    }}
                  >
                    Portfolio snapshot
                  </div>
                </div>

                <div className="hero-profile-main">
                  <div className="stats-grid stats-grid-3">
                    <div className="stat-card">
                      <div className="stat-label">Experience</div>
                      <div className="stat-value">4+</div>
                      <div className="stat-sub">
                        SWE · ML · Research · Teaching
                      </div>
                    </div>
                    <div className="stat-card">
                      <div className="stat-label">Projects</div>
                      <div className="stat-value">5+</div>
                      <div className="stat-sub">
                        Real-time · Trading · Media · Fraud · NLP
                      </div>
                    </div>
                    <div className="stat-card">
                      <div className="stat-label">Focus</div>
                      <div className="stat-sub">
                        Backend · Full-stack · Machine Learning
                      </div>
                    </div>
                  </div>
                  <div className="hero-profile-tags">
                    <span className="hero-profile-tag">
                      C / C++ / C# (.NET)
                    </span>
                    <span className="hero-profile-tag">
                      Python · JavaScript · Java
                    </span>
                    <span className="hero-profile-tag">
                      React · Node · Next.js
                    </span>
                    <span className="hero-profile-tag">
                      AWS · Docker · Kubernetes
                    </span>
                    <span className="hero-profile-tag">
                      SQL · PostgreSQL · MongoDB
                    </span>
                  </div>
                </div>

                <div className="hero-profile-footer">
                  <a href="#contact" className="hero-profile-cta">
                    Say hi →
                  </a>
                </div>
              </aside>
            </div>
          </section>

          {/* EXPERIENCE */}
          <section id="experience" style={{ marginTop: 70 }}>
            <h2
              style={{
                fontSize: 18,
                textTransform: "uppercase",
                letterSpacing: "0.15em",
                color: "#f9a8d4",
                marginBottom: 8,
              }}
            >
              Experience
            </h2>
            <p
              style={{
                color: "var(--muted)",
                maxWidth: 440,
                fontSize: 14,
                marginBottom: 18,
              }}
            ></p>
            {/* UIT Vietnam */}
            <div className="exp-card">
              <img
                className="exp-logo"
                src="https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcT22O4ka7nvYENrjnY71p3poXNx9VfCR_f21w&s"
                alt="UIT Vietnam"
              />

              <div>
                <div className="exp-title">
                  <span className="exp-company">Google</span>

                  <span className="exp-role">
                    Google For Developers Program
                  </span>
                </div>
                <ul className="exp-details">
                  <li>
                    ML / NLP: BERT-based emotion classification, feature
                    engineering
                  </li>
                  <li>
                    ML Platforms: Vertex AI, BigQuery ML, automated model
                    evaluation
                  </li>
                  <li>
                    Cloud & APIs: Google Cloud Platform, Gemini API, model
                    monitoring
                  </li>
                </ul>
              </div>
            </div>
            {/* UIT Vietnam */}
            <div className="exp-card">
              <img
                className="exp-logo"
                src="data:image/jpeg;base64,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"
                alt="UIT Vietnam"
              />

              <div>
                <div className="exp-title">
                  <span className="exp-company">Deloitte</span>

                  <span className="exp-role">
                    Software Engineer Intern (Fraud Detection Team)
                  </span>
                </div>
                <ul className="exp-details">
                  <li>
                    Backend / Distributed Systems: Golang APIs, Kafka message
                    queues, Redis Streams
                  </li>
                  <li>
                    DevOps / CI/CD: GitHub Actions, Docker Compose, automated
                    testing, deployment pipelines
                  </li>
                  <li>
                    Machine Learning / Data: Fraud risk scoring models, K-fold
                    cross-validation, hyperparameter tuning
                  </li>
                </ul>
              </div>
            </div>

            <div style={{ display: "flex", flexDirection: "column", gap: 16 }}>
              {/* Bettr Analytics */}
              <div className="exp-card">
                <img
                  className="exp-logo"
                  src="data:image/png;base64,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"
                  alt="Bettr Analytics"
                />
                <div>
                  <div className="exp-title">
                    <span className="exp-company">Bettr Analytics</span>

                    <span className="exp-role">
                      Software Engineer Intern (Web Development Team)
                    </span>
                  </div>
                  <ul className="exp-details">
                    <li>
                      Frontend / NLP Interfaces: React.js, Redux, Bootstrap,
                      chatbot UI for data insights
                    </li>
                    <li>
                      Backend / APIs: Java Spring Boot, MySQL, AWS EC2,
                      timestamped message logging, file retrieval APIs
                    </li>
                    Testing / Quality: Unit & integration testing with Pytest,
                    pytest-mock, Selenium
                  </ul>
                </div>
              </div>

              {/* UIT Vietnam */}
              <div className="exp-card">
                <img
                  className="exp-logo"
                  src="data:image/png;base64,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"
                  alt="UIT Vietnam"
                />
                <div>
                  <div className="exp-title">
                    <span className="exp-company">
                      University of Information Technology
                    </span>

                    <span className="exp-role">
                      Machine Learning Intern (NLP Research Team)
                    </span>
                  </div>
                  <ul className="exp-details">
                    <li>Python, Pandas, spaCy</li>
                    <li>Models: Scikit-learn SVM, PCA, Gradient Boosting</li>
                  </ul>
                </div>
              </div>

              {/* Denison Research */}
              <div className="exp-card">
                <img
                  className="exp-logo"
                  src="data:image/png;base64,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"
                  alt="Denison"
                />
                <div>
                  <div className="exp-title">
                    <span className="exp-company">Denison University</span>

                    <span className="exp-role">
                      Student Researcher (Quantitative Social Analytics Lab)
                    </span>
                  </div>
                  <ul className="exp-details">
                    <li>Data Analysis: R, Excel</li>
                    <li>Visualization: Tableau, Power BI</li>
                    <li>Modeling: Statistical & Mathematical Modeling</li>
                  </ul>
                </div>
              </div>

              {/* CS Teaching Assistant */}
              <div className="exp-card">
                <img
                  className="exp-logo"
                  src="data:image/png;base64,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"
                  alt="Denison CS"
                />
                <div>
                  <div className="exp-title">
                    <span className="exp-company">CS Teaching Assistant</span>
                    <span className="exp-role"></span>
                  </div>
                  <ul className="exp-details">
                    <li>Data Structures and Algorithm (CS 271)</li>
                    <li>Object-Oriented Programming C++ (CS 173)</li>
                  </ul>
                </div>
              </div>
            </div>
          </section>

          {/* PROJECTS */}
          <section id="projects" style={{ marginTop: 70 }}>
            <h2
              style={{
                fontSize: 18,
                textTransform: "uppercase",
                letterSpacing: "0.15em",
                color: "#f9a8d4",
                marginBottom: 8,
              }}
            >
              Projects
            </h2>
            <p
              style={{
                color: "var(--muted)",
                maxWidth: 440,
                fontSize: 14,
                marginBottom: 18,
              }}
            ></p>
            <div
              style={{
                display: "grid",
                gridTemplateColumns: "repeat(auto-fit,minmax(260px,1fr))",
                gap: 18,
              }}
            >
              <div
                style={{
                  padding: 18,
                  borderRadius: 18,
                  border: "1px solid rgba(148,163,184,.65)",
                  background:
                    "radial-gradient(circle at top left,rgba(148,163,184,.22),#020617)",
                }}
              >
                <h3 style={{ fontSize: 15, marginBottom: 6 }}>
                  Crypto Pilot - Trading
                </h3>
                <p style={{ fontSize: 14, color: "#cbd5f5", marginBottom: 6 }}>
                  Real-time crypto trading platform with low-latency data
                  streaming, secure authentication, and cloud deployment.
                </p>
                <p style={{ fontSize: 12, color: "var(--muted)" }}>
                  MongoDB · React.js · Node.js · Express.js · AWS · Redis ·
                  Binance API
                </p>
              </div>

              <div
                style={{
                  padding: 18,
                  borderRadius: 18,
                  border: "1px solid rgba(148,163,184,.65)",
                  background:
                    "radial-gradient(circle at top left,rgba(148,163,184,.22),#020617)",
                }}
              >
                <h3 style={{ fontSize: 15, marginBottom: 6 }}>
                  Media Processing Platform
                </h3>
                <p style={{ fontSize: 14, color: "#cbd5f5", marginBottom: 6 }}>
                  Scalable media processing system with asynchronous pipelines,
                  containerized services, and secure storage.
                </p>
                <p style={{ fontSize: 12, color: "var(--muted)" }}>
                  Flask · React.js · Docker · PostgreSQL · Celery · Nginx
                </p>
              </div>
            </div>
          </section>

          {/* CONTACT */}
          <section id="contact" style={{ marginTop: 70, marginBottom: 70 }}>
            <h2
              style={{
                fontSize: 18,
                textTransform: "uppercase",
                letterSpacing: "0.15em",
                color: "#f9a8d4",
                marginBottom: 8,
              }}
            >
              Contact
            </h2>
            <p
              style={{
                color: "var(--muted)",
                maxWidth: 440,
                fontSize: 14,
                marginBottom: 18,
              }}
            >
              Let’s chat about internships, projects, or anything techy.
            </p>

            <div
              style={{
                display: "grid",
                gridTemplateColumns: "minmax(0,1fr) minmax(0,1fr)",
                gap: 20,
              }}
            >
              {/* left: form */}
              <div
                style={{
                  padding: 20,
                  borderRadius: 18,
                  border: "1px solid rgba(148,163,184,.65)",
                  background:
                    "radial-gradient(circle at top left,rgba(249,168,212,.18),#020617)",
                }}
              >
                <h3 style={{ fontSize: 16, marginBottom: 10 }}>
                  Send a message
                </h3>
                <form
                  action="mailto:nguyen_j6@denison.edu"
                  method="POST"
                  encType="text/plain"
                  style={{ display: "grid", gap: 10 }}
                >
                  <input
                    name="name"
                    placeholder="Your name"
                    required
                    style={{
                      padding: "10px 12px",
                      borderRadius: 14,
                      border: "1px solid rgba(148,163,184,.65)",
                      background: "rgba(15,23,42,.95)",
                      color: "#f9fafb",
                      fontSize: 13,
                    }}
                  />
                  <input
                    name="email"
                    type="email"
                    placeholder="you@example.com"
                    required
                    style={{
                      padding: "10px 12px",
                      borderRadius: 14,
                      border: "1px solid rgba(148,163,184,.65)",
                      background: "rgba(15,23,42,.95)",
                      color: "#f9fafb",
                      fontSize: 13,
                    }}
                  />
                  <textarea
                    name="message"
                    placeholder="What would you like to chat about?"
                    required
                    style={{
                      padding: "10px 12px",
                      borderRadius: 14,
                      border: "1px solid rgba(148,163,184,.65)",
                      background: "rgba(15,23,42,.95)",
                      color: "#f9fafb",
                      minHeight: 90,
                      fontSize: 13,
                    }}
                  />
                  <AnimatedButton variant="primary" type="submit">
                    Send message
                  </AnimatedButton>
                </form>
              </div>

              {/* right: Elsewhere */}
              <div
                style={{
                  padding: 20,
                  borderRadius: 18,
                  border: "1px solid rgba(148,163,184,.65)",
                  background:
                    "radial-gradient(circle at top left,rgba(249,168,212,.18),#020617)",
                }}
              >
                <h3 style={{ fontSize: 16, marginBottom: 10 }}>
                  Connect with me
                </h3>
                <ul
                  style={{
                    listStyle: "none",
                    padding: 0,
                    margin: 0,
                    fontSize: 14,
                  }}
                >
                  <li className="elsewhere-item">
                    📧 Email:
                    <a
                      href="mailto:nguyen_j6@denison.edu"
                      className="elsewhere-pill elsewhere-email"
                    >
                      nguyen_j6@denison.edu
                    </a>
                  </li>

                  <li className="elsewhere-item">
                    💼 LinkedIn:
                    <a
                      href="https://www.linkedin.com/in/-jennynguyen/"
                      target="_blank"
                      rel="noreferrer"
                      className="elsewhere-pill elsewhere-linkedin"
                    >
                      Visit profile ↗
                    </a>
                  </li>

                  <li className="elsewhere-item">
                    🧑‍💻 GitHub:
                    <a
                      href="https://github.com/jennykhanhnguyen"
                      target="_blank"
                      rel="noreferrer"
                      className="elsewhere-pill elsewhere-github"
                    >
                      Browse repos ↗
                    </a>
                  </li>

                  <li className="elsewhere-item">
                    📄 Resume:
                    <a
                      href="https://drive.google.com/file/d/1NghH0pW9gGf-K7XgycO2THE0UR3HDRG5/view?usp=sharing"
                      target="_blank"
                      rel="noreferrer"
                      className="elsewhere-pill elsewhere-resume"
                    >
                      Download PDF ↗
                    </a>
                  </li>
                </ul>

                <p
                  style={{
                    color: "var(--muted)",
                    fontSize: 13,
                    marginTop: 10,
                  }}
                >
                  I try to respond within a few days. I’m always happy to talk
                  about internships, SWE/ML work, or any new ideas.
                </p>
              </div>
            </div>
          </section>
        </div>
      </main>

      <footer
        style={{
          padding: "20px 0",
          textAlign: "center",
          color: "var(--muted)",
          fontSize: 13,
          borderTop: "1px solid rgba(148,163,184,.3)",
        }}
      >
        Built with code, matcha and pink © {new Date().getFullYear()}
      </footer>
    </>
  );
};

export default App;
